module.exports = __webpack_public_path__ + "static/media/checkin_art.09503379.jpg";